import { createAsyncThunk } from '@reduxjs/toolkit';
import { getConnectwiseServiceBoards } from 'services/connectwise';

export const ThunkGetConnectwiseServiceBoards = createAsyncThunk(
  'connectwise/getConnectwiseServiceBoards',
  (psaId: number) =>
    getConnectwiseServiceBoards(psaId)
      .then(res => res.data)
      .then(data => data.sort((a, b) => a.name.localeCompare(b.name))),
);

export default {};
